import React, { useEffect, useState } from 'react';
import styles from './edit-profile-info.module.scss';
import { DefaultButton, FormInput } from 'shared/ui';
import { validateEditProfileInfo } from '../model/validate-edit-profile-info';
import { userStore } from 'entities/index';
import { MailConfirmationInput } from 'features/index';
import { VerificationCodeEnum } from 'shared/types';

interface EditProfileInfoProps {
  dataFio: string;
  dataEmail: string;
  dataPhone: string;
  updateData: (email: string, fio: string, phone: string) => void;
}

export const EditProfileInfo: React.FC<EditProfileInfoProps> = ({
  dataFio,
  dataEmail,
  dataPhone,
  updateData,
}) => {
  const [fio, setFio] = useState(dataFio);
  const [email, setEmail] = useState(dataEmail);
  const [phone, setPhone] = useState(dataPhone);
  const [validationError, setValidationError] = useState('');

  useEffect(() => {
    setFio(dataFio);
    setPhone(dataPhone);
    setEmail(dataEmail);
  }, [dataFio, dataEmail, dataPhone]);

  const handleSubmit = async () => {
    const errors = validateEditProfileInfo(fio, email, phone);
    if (!errors) {
      try {
        await updateData(email, fio.trim(), phone);
        await userStore.init();
      } catch (error) {
        if (error instanceof Error) {
          setValidationError(error.message);
        }
      }
    } else {
      setValidationError(errors);
    }
  };

  return (
    <div className={styles.edit_profile_info}>
      <div className={styles.edit_profile_info__content}>
        <div className={styles.content__inputs}>
          <div className={styles.inputs__input}>
            <FormInput
              inputValue={fio}
              inputTitle="ФИО"
              inputPlaceholder="Фамилия Имя Отчество"
              onChange={(value) => {
                setFio(value);
              }}
            />
          </div>
          <div className={styles.inputs__input}>
            <FormInput
              inputValue={phone}
              isPhone={true}
              inputTitle="Номер телефона"
              onChange={(value) => {
                setPhone(value.match(/\d+/g)?.join('') ?? '');
              }}
            />
          </div>
          <div className={styles.inputs__input}>
            <MailConfirmationInput
              onChange={(value) => {
                setEmail(value);
              }}
              type={VerificationCodeEnum.EMAIL_VERIFICATION}
            />
          </div>
        </div>
        <div className={styles.content__buttons}>
          {validationError ? (
            <div className={styles.buttons__error}>{validationError}</div>
          ) : undefined}
          <div className={styles.buttons_button} onClick={handleSubmit}>
            <DefaultButton buttonText="Сохранить изменения" color="white" />
          </div>
        </div>
      </div>
    </div>
  );
};
